const heicExtensions = ['heic', 'heif'];

export function isHeicFile(file: File): boolean {
  if (!file) return false;

  const fileName = file.name.toLowerCase();
  const mimeType = file.type.toLowerCase();

  // character | means "or"
  // i means case insensitive
  const pattern = new RegExp(heicExtensions.join('|'), 'i');

  if (pattern.test(mimeType)) {
    return true;
  }

  return heicExtensions.some(ext => fileName.endsWith(`.${ext}`));
}
